import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**
 * Skeleton loader for Collection Card
 * Matches collection cards layout in collections/page.tsx
 */
export const CollectionCardSkeleton: React.FC = () => {
  return (
    <div className="card elev-sm" style={{ padding: 0, overflow: 'hidden' }}>
      <div className="relative" style={{ aspectRatio: '4 / 3' }}>
        <Skeleton height="100%" style={{ position: 'absolute', inset: 0 }} />
      </div>

      <div style={{ padding: 'var(--space-4)' }}>
        <Skeleton height={20} width="75%" style={{ marginBottom: 'var(--space-1)' }} />
        <Skeleton count={2} style={{ marginBottom: 'var(--space-3)' }} />
        <Skeleton width={110} height={16} />
      </div>
    </div>
  );
};

export default CollectionCardSkeleton;
